import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
const membershipStatusIconMap = {
    accepted: React.createElement(CheckCircleIcon, { htmlColor: themeColors.accent.green.base }),
    rejected: React.createElement(CancelIcon, { htmlColor: themeColors.accent.red.base }),
    withdrawn: React.createElement(RemoveCircleIcon, { htmlColor: themeColors.accent.grey.base }),
    pending: React.createElement(ErrorIcon, { htmlColor: themeColors.accent.orange.base }),
    researching: React.createElement(InfoIcon, { htmlColor: themeColors.accent.blue.base }),
};
export const AccountMembershipStatus = ({ status }) => {
    const settings = useSelector(getSettings);
    const { orgStatusMap } = settings;
    return (React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center', flex: '1 50%' }, "data-test": 'membership-status' },
        membershipStatusIconMap[status],
        orgStatusMap[status].label));
};
